export enum GPSyncStatusCode {
  Pending = "Pending",
  InProgress = "InProgress",
  Synchronized = "Synchronized",
  Failed = "Failed",
}

export default GPSyncStatusCode;
